import jwt from 'jsonwebtoken';

export const decodeToken = (token : string, publicKey : string) : string | object => {
  return jwt.verify(token, publicKey, { algorithms: [ 'ES256' ] });
};
